import type { GetInvoicesResponse, Invoice } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { subscriptionKeys } from "@/hooks/queryKeys";

const MOCK_INVOICE_COUNT = 24;
const MOCK_INVOICE_TOTAL = "3600";
const MOCK_INVOICE_DAY = 20;

interface UseInvoicesParams {
  limit: number;
  page: number;
  projectId: number;
}

export function useInvoices({
  limit,
  page,
  projectId,
}: UseInvoicesParams): UseQueryResult<GetInvoicesResponse> {
  return useQuery<GetInvoicesResponse>({
    placeholderData: keepPreviousData,
    queryFn: () => paginateInvoices(buildMockInvoices(projectId), page, limit),
    queryKey: subscriptionKeys.invoices(projectId, page, limit),
  });
}

export function buildMockInvoices(projectId: number): Invoice[] {
  const latest = dayjs().date(MOCK_INVOICE_DAY).startOf("day");

  return Array.from({ length: MOCK_INVOICE_COUNT }, (_, index) => {
    const date = latest.subtract(index, "month");
    const sequence = String(MOCK_INVOICE_COUNT - index).padStart(6, "0");

    return {
      currency: "USD",
      date: date.toISOString(),
      description: "Marketing - Fully-managed - 5 design slots",
      id: `INV-${date.format("YYYYMMDD")}-${sequence}-${projectId}`,
      status: index === 0 ? "overdue" : "paid",
      total: MOCK_INVOICE_TOTAL,
    };
  });
}

export function paginateInvoices(
  invoices: Invoice[],
  page: number,
  limit: number,
): GetInvoicesResponse {
  const start = (page - 1) * limit;

  return {
    items: invoices.slice(start, start + limit),
    pagination: {
      limit,
      page,
      totalPages: Math.ceil(invoices.length / limit),
    },
    total: invoices.length,
  };
}
